/* eslint-disable no-console */
import Layer from 'services/models/Layer';
import Coordinate from 'services/utils/Coordinate';
import { measureArea, measureLength } from 'services/utils/measures';

/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */

import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';

export const initialToolState = {
  // Marker, Line, Polygon, Circle
  activeItem: null,
  selectedFeature: null,
  features: [],
  layerNameToSave: '',
  layerStyleToSave: null,
  saveLayerNameError: '',
  displaySaveModal: false,
};

export default (state, action) => {  

  const removeAllFeatures = () => {
    state.features.forEach((feature) => {
      feature.remove();
    });
  };

  const checkLayerName = (layerNameToSave) => {
    let saveLayerNameError = '';
    saveLayerNameError =
      layerNameToSave && layerNameToSave.trim()
        ? layerNameToSave.length <= 70
          ? ''
          : 'Nome da camada não deve ter mais que 70 caracteres.'
        : 'Campo obrigatório.';
    return saveLayerNameError;
  };

  switch (action.type) {
    case 'selectOrToogleActiveItem': {
      const activeItem =
        state.activeItem === action.payload ? null : action.payload;
      return { ...state, activeItem };
    }
    case 'selectFeature':
      return { ...state, selectedFeature: action.payload };
    case 'setFeatures':
      return { ...state, features: action.payload };
    case 'addFeature':
      return { ...state, features: [...state.features, action.payload] };
    case 'deleteAllFeatures': {
      if (action.payload?.silent) {
        state.features.forEach((feature) => feature.remove());
        return { ...state, features: [], coordsList: [] };
      } else {
        return state;
      }
    }
    case 'deleteFeature': {
      let newFeatures = state.features.filter((f) => {
        if (f._leaflet_id === action.payload) {
          f.remove();
          return false;
        } else return true;
      });
      return {
        ...state,
        features: newFeatures,
      };
    }
    case 'openSaveModal':
      return { ...state, displaySaveModal: true };
    case 'closeSaveModal':
      return { ...state, displaySaveModal: false };
    case 'setLayerNameToSave': {
      const layerNameToSave = action.payload;
      let saveLayerNameError = checkLayerName(layerNameToSave);
      return { ...state, layerNameToSave, saveLayerNameError };
    }
    case 'setLayerStyleToSave':
      return { ...state, layerStyleToSave: action.payload };
    case 'saveAsLayer': {
      if (
        state.layerNameToSave !== '' &&
        state.saveLayerNameError === '' &&
        state.features.length > 0
      ) {
        let featuresList = state.features.map((f, i) => {
          f.remove();          
          let featureToReturn = f.toGeoJSON(14);                    
          if (f instanceof L.Circle) {
            let center = [f.getLatLng().lng, f.getLatLng().lat];
            let radius = f.getRadius();
            let polygonCircle = turf.circle(center, radius, {
              units: 'meters',
            });
            featureToReturn = polygonCircle;
          }
          featureToReturn.properties.ID_GBA = i + 1;
          if (!(f instanceof L.Marker)) {
            if (state.selectedFeature === 'Line') {             
              featureToReturn.properties[
                'Comprimento (m)'
              ] = measureLength(featureToReturn.geometry.coordinates, true);
            } else {                          
              featureToReturn.properties['Área (m²)'] = measureArea(featureToReturn.geometry.coordinates, true);
              featureToReturn.properties['Área (ha)'] = measureArea(featureToReturn.geometry.coordinates, true) / 10000;
            }
          } else {            
            let coordsDMS = Coordinate.convertDDToDMS([f.getLatLng().lat, f.getLatLng().lng]);  
            featureToReturn.properties['Latitude'] = coordsDMS[0];
            featureToReturn.properties['Longitude'] = coordsDMS[1];
          }
          return featureToReturn;
        });
        removeAllFeatures();
        const newLayer = turf.featureCollection(featuresList);
        const customRender = L.canvas({ pane: 'mixedPane' });
        let options = {
          pane: 'mixedPane',
          renderer: customRender,
          style: state.layerStyleToSave,
        };
        if (state.selectedFeature === 'Marker') {
          options = {
            ...options,
            // ? Não poderia ser um utils do leaflet geral ?
            pointToLayer: function (feature, latlng) {
              return L.circleMarker(latlng, {
                pane: 'mixedPane',
                ...state.layerStyleToSave,
                renderer: customRender,
              });
            },
          };
        }
        const geoJsonLayer = L.geoJSON(newLayer, options);        
        let layerToAdd = new Layer(
          null,
          'criada',
          null,
          state.layerNameToSave,
          null,
          null,
          null,
          null,
          null
        );
        layerToAdd.setLeafletLayer(geoJsonLayer);
        layerToAdd.setLayerStyle(state.layerStyleToSave);
        action.payload.mapContext.addLayer(layerToAdd);
        action.payload.callback({
          ...state,
          features: [],
          coordsList: [],
          displaySaveModal: false,
          layerNameToSave: '',
          saveLayerNameError: '',
        });
        return {
          ...state,
          features: [],
          coordsList: [],
          displaySaveModal: false,
          layerNameToSave: '',
          saveLayerNameError: '',
        };
      } else {
        let saveLayerNameError = checkLayerName(state.layerNameToSave);
        action.payload.callback({
          error: saveLayerNameError,
        });
        return { ...state, saveLayerNameError };
      }
    }
    default:
      throw new Error();
  }
};
